import { IELTLastMeetingData } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { memo } from 'react'

interface IProps {
  item: IELTLastMeetingData
}

export const ReadOnlyFields = memo<IProps>(({ item }) => (
  <>
    <td>
      <div>{item.status}</div>
    </td>
    <td>
      <div>{item.action}</div>
    </td>
    <td>
      <div>{item.update}</div>
    </td>
  </>
))
